/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_Stopimpersonation1Inputs */

const tr_impersonation_stopimpersonation1 = /** @type {(inputs: Impersonation_Stopimpersonation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taklidi Durdur`)
};

const en_impersonation_stopimpersonation1 = /** @type {(inputs: Impersonation_Stopimpersonation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop Impersonating`)
};

/**
* | output |
* | --- |
* | "Stop Impersonating" |
*
* @param {Impersonation_Stopimpersonation1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const impersonation_stopimpersonation1 = /** @type {((inputs?: Impersonation_Stopimpersonation1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_Stopimpersonation1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_impersonation_stopimpersonation1(inputs)
	return en_impersonation_stopimpersonation1(inputs)
});
export { impersonation_stopimpersonation1 as "impersonation_stopImpersonation" }